<!--begin::Form-->
<form class="form w-100" [formGroup]="loginForm" novalidate="novalidate" id="kt_login_signin_form" (ngSubmit)="submit()">
   <!--begin::Heading-->
   <div class="text-center mb-11">
      <!--begin::Logo-->
      <a routerLink="/" class="mb-3">
         <img loading="lazy" alt="Logo" src="./media/logos/logoLg.png" class="h-200px" />
      </a>
      <!--end::Logo-->

      <!--begin::Title-->
      <h1 class="text-dark fw-bolder m-3 mb-3">Sign In</h1>
      <!--end::Title-->
      <!--begin::Subtitle-->
      <div class="text-gray-500 fw-semibold fs-6">Connect with your IT team</div>
      <!--end::Subtitle=-->
   </div>
   <!--end::Heading-->

   <!--begin::Form group-->
   <div class="fv-row mb-8">
      <label for="userName" class="form-label fs-6 fw-bolder text-dark">User Name</label>
      <input
         class="form-control bg-transparent"
         type="userName"
         name="userName"
         formControlName="userName"
         autocomplete="off"
         [ngClass]="{
            'is-invalid': loginForm.controls['userName'].invalid,
            'is-valid': loginForm.controls['userName'].valid
         }"
      />
      <ng-container
         [ngTemplateOutlet]="formError"
         [ngTemplateOutletContext]="{
            validation: 'required',
            message: 'userName is required',
            control: loginForm.controls['userName']
         }"
      ></ng-container>
      <ng-container
         [ngTemplateOutlet]="formError"
         [ngTemplateOutletContext]="{
            validation: 'minLength',
            message: 'userName should have at least 3 symbols',
            control: loginForm.controls['userName']
         }"
      ></ng-container>
      <ng-container
         [ngTemplateOutlet]="formError"
         [ngTemplateOutletContext]="{
            validation: 'maxLength',
            message: 'userName should have maximum 100 symbols',
            control: loginForm.controls['userName']
         }"
      ></ng-container>
   </div>
   <!--end::Form group-->

   <!--begin::Form group-->
   <div class="fv-row mb-3">
      <label for="password" class="form-label fw-bolder text-dark fs-6 mb-0">Password</label>

      <input
         class="form-control bg-transparent"
         type="password"
         name="password"
         autocomplete="off"
         formControlName="password"
         [ngClass]="{
            'is-invalid': loginForm.controls['password'].invalid,
            'is-valid': loginForm.controls['password'].valid
         }"
      />
      <ng-container
         [ngTemplateOutlet]="formError"
         [ngTemplateOutletContext]="{
            validation: 'required',
            message: 'Password is required',
            control: loginForm.controls['password']
         }"
      ></ng-container>
      <ng-container
         [ngTemplateOutlet]="formError"
         [ngTemplateOutletContext]="{
            validation: 'minlength',
            message: 'Password should have at least 3 symbols',
            control: loginForm.controls['password']
         }"
      ></ng-container>
      <ng-container
         [ngTemplateOutlet]="formError"
         [ngTemplateOutletContext]="{
            validation: 'maxLength',
            message: 'Password should have maximum 100 symbols',
            control: loginForm.controls['password']
         }"
      ></ng-container>
   </div>
   <!--end::Form group-->

   <!--begin::Action-->
   <div class="d-grid mb-10">
      <button type="submit" id="kt_sign_in_submit" class="btn btn-primary" [disabled]="loginForm.invalid">
         @if (isLoading$ | async) {
         <span class="indicator-progress" [style.display]="'block'">
            Please wait...
            <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
         </span>
         } @if ((isLoading$ | async) === false) {
         <span class="indicator-label">Continue</span>
         }
      </button>
   </div>

   <!--end::Action-->
</form>
<!--end::Form-->

<ng-template #formError let-control="control" let-message="message" let-validation="validation">
   @if (control.hasError(validation) && (control.dirty || control.touched)) {
   <div class="fv-plugins-message-container text-danger font-weight-bold">
      <span role="alert">
         {{ message }}
      </span>
   </div>
   }
</ng-template>
